// RSF Thumbnail — sync swiper dots with scroll position + image load detection.
(function () {
  'use strict';

  /* Video autoplay: inner-scroll containers + browser policy strict — forziamo .play()
     quando video entra in viewport (≥25% visible) e .pause() quando esce. CPU-friendly. */
  var videoObserver = null;
  function initVideoAutoplay(root) {
    if (!('IntersectionObserver' in window)) return;
    if (!videoObserver) {
      videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            // Promise-based per evitare uncaught promise rejection su browser policy
            var p = v.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
    }
    var videos = (root || document).querySelectorAll('.rsf-card-product__slide-video');
    videos.forEach(function (v) {
      if (v.dataset.rsfAutoplayInit) return;
      v.dataset.rsfAutoplayInit = '1';
      v.muted = true; // browser policy: autoplay solo se muted
      v.playsInline = true;
      videoObserver.observe(v);
    });
  }

  /* Loading spinner: per ogni slide (img o video), rimuove .is-loading quando ready.
     - <img>: load event (o complete+naturalWidth>0 se cached)
     - <video>: loadeddata event (frame disponibile, abbastanza per render)
     Plus: legacy single .rsf-card-product__image gestito stesso modo. */
  function initImageLoaders(root) {
    // Per-slide loading state
    var slides = (root || document).querySelectorAll('.rsf-card-product__slide.is-loading');
    slides.forEach(function (slide) {
      var media = slide.querySelector('.rsf-card-product__slide-img, .rsf-card-product__slide-video');
      if (!media) { slide.classList.remove('is-loading'); return; }
      var done = function () { slide.classList.remove('is-loading'); };
      if (media.tagName === 'VIDEO') {
        if (media.readyState >= 2) { done(); return; } // HAVE_CURRENT_DATA
        media.addEventListener('loadeddata', done, { once: true });
        media.addEventListener('error', done, { once: true });
      } else {
        if (media.complete && media.naturalWidth > 0) { done(); return; }
        media.addEventListener('load', done, { once: true });
        media.addEventListener('error', done, { once: true });
      }
    });

    // Legacy single image (no swiper)
    var legacyMedias = (root || document).querySelectorAll('.rsf-card-product__media.is-loading');
    legacyMedias.forEach(function (media) {
      var img = media.querySelector('.rsf-card-product__image');
      if (!img) { media.classList.remove('is-loading'); return; }
      var done = function () { media.classList.remove('is-loading'); };
      if (img.complete && img.naturalWidth > 0) { done(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  /* Random pool sampling — SOLO shape card (rsf-shapes-grid), richiesta Daniel
     2026-05-18. I thumbnail prodotto NON sono random (deterministici Liquid).
     Shape card: slide 1 fissa, le altre (no video) mischiate Fisher-Yates e
     campionate a MAX_POOL_SHAPE. Dots ricostruiti per matchare gli slide. */
  var MAX_POOL_SHAPE = 7;  // shape card aggrega + colorway → più varietà
  function randomizeSlides(media) {
    /* SOLO shape card: i thumbnail prodotto restano DETERMINISTICI (richiesta
       Daniel 2026-05-18). Il random vive esclusivamente in rsf-shapes-grid. */
    var card = media.closest ? media.closest('.rsf-card-product') : null;
    if (!card || !card.classList.contains('rsf-card-product--shape')) return;
    var slides = media.querySelector('.rsf-card-product__slides');
    if (!slides || slides.dataset.rsfPoolDone) return;
    slides.dataset.rsfPoolDone = '1';
    var video = slides.querySelector('.rsf-card-product__slide--video');
    var all = Array.prototype.slice.call(slides.querySelectorAll('.rsf-card-product__slide'));
    if (all.length < 3) return;
    /* video-first: il Liquid (rsf-shapes-grid) ha messo il video come slide 1
       per le forme selezionate (≈40%). In quel caso il video RESTA primo,
       la frontale catalogo va seconda (ruotata via CSS), le altre shufflate.
       Altrimenti (nessun video / video non primo) → legacy: frontale prima,
       pool random, video in coda. */
    var videoFirst = video && all[0] === video;
    var fixed, frontal, pool;
    if (videoFirst) {
      fixed = video;
      frontal = all[1] || null;
      pool = all.slice(2);
    } else {
      fixed = all[0];
      frontal = null;
      pool = all.slice(1).filter(function (el) { return el !== video; });
    }
    var cap = MAX_POOL_SHAPE;
    if (pool.length < 2 && !fixed) return;
    for (var i = pool.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
    }
    var keep = pool.slice(0, cap);
    pool.slice(cap).forEach(function (el) { el.remove(); });
    var order = [];
    if (fixed) order.push(fixed);
    if (frontal) order.push(frontal);
    keep.forEach(function (el) { order.push(el); });
    if (!videoFirst && video) order.push(video);
    order.forEach(function (el) { slides.appendChild(el); });
    var dotsWrap = media.querySelector('.rsf-card-product__dots');
    if (dotsWrap) {
      var slideCount = slides.querySelectorAll('.rsf-card-product__slide').length;
      dotsWrap.innerHTML = '';
      for (var d = 0; d < slideCount; d++) {
        var span = document.createElement('span');
        span.className = 'rsf-dot' + (d === 0 ? ' rsf-dot--active' : '');
        dotsWrap.appendChild(span);
      }
    }
  }

  function initSwipers(root) {
    var medias = (root || document).querySelectorAll('.rsf-card-product__media');
    medias.forEach(function (media) {
      if (media.dataset.rsfSwiperInit) return;
      randomizeSlides(media);
      var slides = media.querySelector('.rsf-card-product__slides');
      var dots = media.querySelectorAll('.rsf-card-product__dots .rsf-dot');
      if (!slides || !dots.length) return;
      media.dataset.rsfSwiperInit = '1';
      function update() {
        var idx = Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('rsf-dot--active', i === idx);
        });
      }
      slides.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    });
    // Init image loaders + video autoplay together with swipers
    initImageLoaders(root);
    initVideoAutoplay(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initSwipers(document); });
  } else {
    initSwipers(document);
  }
  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', function (e) { initSwipers(e.target); });
  // Re-init on infinite-scroll append (PLP)
  document.addEventListener('rsf:plp:appended', function () { initSwipers(document); });
  // Re-init on product-recommendations async swap (PDP related fetch via web component).
  // Dawn's <product-recommendations> replaces innerHTML after fetch but doesn't fire any
  // public event; observe its mutations to detect new cards and bind swiper/loader.
  if ('MutationObserver' in window) {
    var recObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) {
          initSwipers(m.target);
        }
      });
    });
    document.querySelectorAll('product-recommendations').forEach(function (el) {
      recObs.observe(el, { childList: true, subtree: true });
    });
  }
  // Expose for direct invocation
  window.initRsfSwipers = initSwipers;

  /* ──────────────────────────────────────────────────────────────────────
     Add to cart from card chip [data-rsf-cart-add].
     Event delegation document-level (cards possono essere injected dinamicamente
     da PLP infinite scroll, search, wishlist page, etc.).
     ────────────────────────────────────────────────────────────────────── */
  function flashCardCart(text) {
    var t = document.createElement('div');
    t.textContent = text;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#000;color:#fff;padding:10px 16px;font-family:var(--rsf-font-stack,sans-serif);font-size:11px;letter-spacing:0.04em;text-transform:uppercase;z-index:9999;pointer-events:none;';
    document.body.appendChild(t);
    setTimeout(function () { try { t.remove(); } catch (e) {} }, 2200);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-rsf-cart-add]');
    if (!btn) return;
    /* Block link wrapper della card → niente navigate al PDP */
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    /* Pattern Shopify Section Rendering API: passiamo sections: 'cart-drawer,cart-icon-bubble'
       nel body del POST. Response include sections rerendered HTML che il cart-drawer custom
       element parsa via renderContents(parsedState) per aggiornare il drawer in place + bubble counter. */
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
    .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('add failed')); })
    .then(function (parsedState) {
      flashCardCart('Added to cart');
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState && parsedState.sections) {
        cartDrawer.renderContents(parsedState);
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        /* Fallback: redirect a /cart se niente drawer */
        setTimeout(function () { location.href = '/cart'; }, 800);
        return;
      }
      /* Auto-close drawer dopo 2s (UX: feedback visivo aggiunta + ritorno alla browse).
         Niente cancel su hover/click: renderContents fa innerHTML swap → fire eventi sintetici
         che annullavano il timer. Per riaprire basta un altro click sul cart icon. */
      if (cartDrawer && typeof cartDrawer.close === 'function') {
        setTimeout(function () { cartDrawer.close(); }, 2000);
      }
    })
    .catch(function () { flashCardCart('Add failed'); })
    .then(function () {
      /* Cleanup busy state in entrambi success/fail (sostituzione di .finally per Safari old) */
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
  }, true);

  /* ──────────────────────────────────────────────────────────────────────
     Smart Wishlist chip on cards: il chip è dentro <a class="rsf-card-product__link">
     che farebbe navigate al PDP. preventDefault blocca il follow link MA NON
     stopPropagation: smartwishlist2.js binda via jQuery $(document).on('click', '.smartwishlist')
     in bubble phase — serve che l'evento bubble fino al document.
     ────────────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest && e.target.closest('.rsf-card-product__chip.smartwishlist');
    if (!sw) return;
    e.preventDefault(); /* solo blocca anchor follow, NON stopPropagation */
  }, true);

  /* ──────────────────────────────────────────────────────────────────────
     Sold out · Find a stockist chip: il chip è dentro <a class="rsf-card-product__link">
     che farebbe navigate al PDP. Il chip è un <a> nested → invalid HTML, browser
     gestisce in modo inconsistente. Capture phase: intercetta click sul chip,
     stopPropagation per evitare bubble al parent PDP link, redirect a /pages/store-locator.
     ────────────────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var stockist = e.target && e.target.closest && e.target.closest('[data-rsf-find-stockist]');
    if (!stockist) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = stockist.getAttribute('href') || '/pages/store-locator';
  }, true);
})();
